module.exports = __webpack_public_path__ + "static/IMG_0070-2c3a4135bf11f0814adddea594a4a071.jpg";